module.exports = __webpack_public_path__ + "img/22.aafd7c81.jpg";